/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { TableCell, TableRow } from "@mui/material";
import React, { useMemo } from "react";
import moment from "moment";
// import Table from "../../../../components/common/new/Table/Table";
// import { useSearchParams } from "react-router-dom";
import Table from "../Components/SubscriptionTrendsTable";
import tableStyle from "../../../../theme/styles/table";
import styles from "./SubscriptionTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

// const STATIC_COLUMNS = [
// //  {
// //   displayName: "S.NO",
// //   key: "s.no",
// //  },
// ];

const getDynamicColumns = (searchData) => {
  if (searchData && searchData.length > 0) {
    const { hierarchy } = searchData[0];
    return [
      {
        displayName: hierarchy ?? "-",
        key: hierarchy?.toLowerCase() || "-",
      },
    ];
  }
  return [];
};

const generateMonthColumns = (startDate, months) => {
  const monthColumns = [];
  let currentDate = moment(startDate);

  for (let i = 0; i < months; i++) {
    const monthKey = currentDate.format("MMM").toLowerCase();
    monthColumns.push(
      {
        displayName: "Membership",
        key: `${monthKey}mem`,
      },
      {
        displayName: "VC",
        key: `${monthKey}vc`,
      },
      {
        displayName: "SS",
        key: `${monthKey}fdt`,
      }
    );
    currentDate = currentDate.add(1, "month");
  }

  return monthColumns;
};

const groupByStructureIdAndMonth = (data) => {
  const grouped = {};

  data.forEach((item) => {
    const date = new Date(item.generatedAt);
    const monthYear = `${date.toLocaleString("default", { month: "short" })} ${
      date.getFullYear() % 100
    }`;

    if (!grouped[item.structureId]) {
      grouped[item.structureId] = {};
    }

    if (!grouped[item.structureId][monthYear]) {
      grouped[item.structureId][monthYear] = {
        // hierarchy: item?.hierarchy,
        structureName: item?.structureName,
        totalMemberCount: item.totalMemberCount,
        vcSubscriptionCount: item.vcSubscriptionCount,
        fdtSubscriptionCount: item.fdtSubscriptionCount,
      };
    }
  });

  return grouped;
};

const getUniqueMonths = (data) => {
  const uniqueMonths = new Set();

  data.forEach((item) => {
    const date = new Date(item.generatedAt);
    const monthYear = `${date.toLocaleString("default", { month: "short" })} ${
      date.getFullYear() % 100
    }`;
    uniqueMonths.add(monthYear);
  });

  // Convert months to Date then apply sorting
  const sortedMonths = Array.from(uniqueMonths).sort((a, b) => {
    const [monthA, yearA] = a.split(" ");
    const [monthB, yearB] = b.split(" ");

    const monthIndexA = new Date(`${monthA} 1, 20${yearA}`).getTime();
    const monthIndexB = new Date(`${monthB} 1, 20${yearB}`).getTime();

    return monthIndexA - monthIndexB;
  });

  return sortedMonths;
};

const getRows = ({ searchData }) => {
  const months = getUniqueMonths(searchData);
  const groupedData = groupByStructureIdAndMonth(searchData);

  const totals = {
    totalMemberCount: {},
    vcSubscriptionCount: {},
    fdtSubscriptionCount: {},
  };

  months.forEach((month) => {
    totals.totalMemberCount[month] = 0;
    totals.vcSubscriptionCount[month] = 0;
    totals.fdtSubscriptionCount[month] = 0;
  });

  const rows = Object.keys(groupedData).map((structureId, index) => {
    // const serialNumber = index + 1 + currentPage * pageSize;

    const processedMonths = new Set();
    const structureData = groupedData[structureId];
    const structureNames = new Set();
    Object.values(structureData).forEach((item) => {
      if (item.structureName) {
        structureNames.add(item.structureName);
      }
    });
    const structure = Array.from(structureNames).join(", ") || "NA";

    // const hierarchy = structureData[months[0]]?.hierarchy || "NA";
    return (
      <TableRow style={tableStyle.tableRow} key={index}>
        {/* <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>{serialNumber}</Typography>
        </TableCell> */}
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>{structure}</Typography>
        </TableCell>
        {months.map((month) => {
          if (processedMonths.has(month)) {
            return null;
          }

          processedMonths.add(month);

          const monthData = structureData[month] || {};

          // Add to totals
          totals.totalMemberCount[month] += monthData.totalMemberCount || 0;
          totals.vcSubscriptionCount[month] +=
            monthData.vcSubscriptionCount || 0;
          totals.fdtSubscriptionCount[month] +=
            monthData.fdtSubscriptionCount || 0;
          return (
            <React.Fragment key={`${structureId}-${month}`}>
              <TableCell style={tabelCellWidth.medium}>
                <Typography style={styles.typoghrphyStyle}>
                  {monthData.totalMemberCount || "-"}
                </Typography>
              </TableCell>
              <TableCell style={tabelCellWidth.small}>
                <Typography style={styles.typoghrphyStyle}>
                  {monthData.vcSubscriptionCount || "-"}
                </Typography>
              </TableCell>
              <TableCell style={tabelCellWidth.small}>
                <Typography style={styles.typoghrphyStyle}>
                  {monthData.fdtSubscriptionCount || "-"}
                </Typography>
              </TableCell>
            </React.Fragment>
          );
        })}
      </TableRow>
    );
  });

  // Add Total Row
  const totalRow = (
    <TableRow style={tableStyle.tableRow} key="total-row">
      <TableCell style={tabelCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>Total</strong>
        </Typography>
      </TableCell>
      {/* <TableCell style={tabelCellWidth.medium} /> Empty cell for hierarchy */}
      {months.map((month) => (
        <React.Fragment key={`total-${month}`}>
          <TableCell style={tabelCellWidth.medium}>
            <Typography style={styles.typoghrphyStyle}>
              <strong>{totals.totalMemberCount[month]}</strong>
            </Typography>
          </TableCell>
          <TableCell style={tabelCellWidth.small}>
            <Typography style={styles.typoghrphyStyle}>
              <strong>{totals.vcSubscriptionCount[month]}</strong>
            </Typography>
          </TableCell>
          <TableCell style={tabelCellWidth.small}>
            <Typography style={styles.typoghrphyStyle}>
              <strong>{totals.fdtSubscriptionCount[month]}</strong>
            </Typography>
          </TableCell>
        </React.Fragment>
      ))}
    </TableRow>
  );
  rows.push(totalRow);
  return rows;
};

function ReportTable({ searchData }) {
  // const [searchParams] = useSearchParams();
  // const dateFrom = searchParams.get("startDate");
  //   const dateTo = searchParams.get("endDate");

  const { dateFrom, dateTo } = useMemo(() => {
    if (searchData && searchData.length > 0) {
      const dates = searchData.map((item) => moment(item.generatedAt));
      // Get the earliest and latest dates using moment.min/max
      const minDate = moment.min(dates);
      const maxDate = moment.max(dates);
      return {
        dateFrom: minDate.format("YYYY-MM-DD"),
        dateTo: maxDate.format("YYYY-MM-DD"),
      };
    }
    return { dateFrom: null, dateTo: null };
  }, [searchData]);

  // Logic to calculate number of Months
  const calculateNumberOfMonths = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);

    if (!start.isValid() || !end.isValid()) {
      return 0;
    }

    return end.diff(start, "months") + 1; // Include both start and end months
  };

  const numberOfMonths = useMemo(
    () => calculateNumberOfMonths(dateFrom, dateTo),
    [dateFrom, dateTo]
  );

  const REPORT_TABLE_COL = useMemo(() => {
    const dynamicColumns = generateMonthColumns(dateFrom, numberOfMonths);
    return [...getDynamicColumns(searchData), ...dynamicColumns];
  }, [dateFrom, numberOfMonths]);

  const rows = useMemo(() => {
    return getRows({ searchData });
  }, [searchData]);

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={REPORT_TABLE_COL}
        rows={rows}
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "left",
        }}
        searchData={searchData}
      />
    </div>
  );
}

export default ReportTable;
